import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import BaseSingleOpportunity from './pages/base/BaseSingleOpportunity'
import Construction from './pages/base/Construction'
import Reporting from './pages/Reporting/Reporting'
import Customers from './pages/base/Customers'
import Schedule from './pages/base/Schedule'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
import Users from './pages/base/Users'
import Login from './pages/Login/Login';
import PasswordReset from './pages/Login/PasswordReset';
import Settings from './pages/Settings/Settings'
import Opportunities from './pages/base/Opportunities';
import SingleRevenueLinePage from './pages/SingleRevenueLinePage';
import SingleCustomer from './pages/SingleCustomer/SingleCustomer';
import Contacts from './pages/base/Contacts';
import SingleContact from './pages/SingleContact/SingleContact';
import RevenueLinesFlat from './pages/Modules/RevenueLinesFlat/RevenueLinesFlat';
import BaseCatalogs from './pages/base/BaseCatalogs';
import BaseSingleCatalog from './pages/base/BaseSingleCatalog';
import BaseSingleProduct from './pages/base/BaseSingleProduct';
import WeeklyQuotesReport from './pages/Modules/WeeklyQuotesReport/WeeklyQuotesReport';
import BaseQuoting from './pages/base/BaseQuoting';
import BaseUniqueQuote from './pages/BaseUniqueQuote/BaseUniqueQuote';
import { lazy, Suspense } from 'react';
import DrawingPackageGate from './components/DrawingPackageGate';
const Drawings = lazy(() => import('./pages/Drawings'));
const PublicDrawing = lazy(() => import('./pages/PublicDrawing'));

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path='/drawings/:token' element={<DrawingPackageGate><Suspense fallback={<p>Loading drawing…</p>}><PublicDrawing /></Suspense></DrawingPackageGate>} />
                <Route path='/3d-drawings' element={<ProtectedRoute child={<DrawingPackageGate><Suspense fallback={<p>Loading drawings…</p>}><Drawings /></Suspense></DrawingPackageGate>} />} />
                <Route path='/' element={<Login/>} />
                <Route path='/forgot-password' element={<PasswordReset />} />
                <Route path='/reset-password' element={<PasswordReset complete />} />
                <Route
                    path='/dashboard'
                    element={<ProtectedRoute child={<Dashboard/>} />}
                />

                <Route
                    path='/constr'
                    element={<ProtectedRoute child={<Construction />} />}
                />
                <Route
                    path="/opportunities"
                    element={<ProtectedRoute child={<Opportunities />} />}
                />
                <Route
                    path="/opportunities/:pid"
                    element={<ProtectedRoute child={<BaseSingleOpportunity />} />}
                />
                <Route
                    path="/schedule"
                    element={<ProtectedRoute child={<Schedule />} />}
                />
                <Route
                    path="/settings"
                    element={<ProtectedRoute child={<Settings />}/>}
                />
                <Route
                    path="/reporting"
                    element={<ProtectedRoute child={<Reporting />} />}
                />
                <Route
                    path="/users"
                    element={<ProtectedRoute child={<Users />} />}
                />
                <Route
                    path="/customers"
                    element={<ProtectedRoute child={<Customers />} />}
                />
                <Route
                    path="/contacts"
                    element={<ProtectedRoute child={<Contacts />} />}
                />
                <Route
                    path="/contacts/:id"
                    element={<ProtectedRoute child={<SingleContact />} />}
                />
                <Route
                    path="/lines/:lid"
                    element={<ProtectedRoute child={<SingleRevenueLinePage/>} />}
                />
                <Route
                    path="/customers/:cid"
                    element={<ProtectedRoute child={<SingleCustomer />} />}
                />

                <Route
                    path="/catalogs"
                    element={<ProtectedRoute child={<BaseCatalogs />} />}
                />
                <Route
                    path="/catalogs/:cid"
                    element={<ProtectedRoute child={<BaseSingleCatalog />} />}
                />
                <Route
                    path="/products/:pid"
                    element={<ProtectedRoute child={<BaseSingleProduct />} />}
                />
                <Route
                    path="/base-quoting"
                    element={<ProtectedRoute child={<BaseQuoting />} />}
                />
                <Route
                    path="/base-unique-quote/:qid"
                    element={<ProtectedRoute child={<BaseUniqueQuote />} />}
                />
                <Route
                    path="/base-unique-quote-read-only/:qid"
                    element={<ProtectedRoute child={<BaseUniqueQuote readOnly />} />}
                />

                {/* Modules */}
                <Route
                    path="/modules/revenue-lines-flat"
                    element={<ProtectedRoute roles={['admin', 'manager']} child={<RevenueLinesFlat />} />}
                />
                <Route
                    path="/modules/weekly-quotes-report"
                    element={<ProtectedRoute child={<WeeklyQuotesReport />} />}
                />

            </Routes>
        </Router>
    );
}

export default AppRouter
